export default function useRoleAccess(requiredRoles: string[] = [], userRoles: string[] | null = []) {
  if (!requiredRoles.length || requiredRoles.includes('member') || userRoles?.includes('owner')) return true;
  const roles = !userRoles || !userRoles.length ? ['member'] : userRoles;
  return roles.some((role) => requiredRoles.includes(role)) || false;
}
